import { FaqBlock as FaqBlockTypes } from "@/payload-types";
import RichText from "@onclicks/sharedcomponents/RichText";

export const FaqList = (props: FaqBlockTypes) => {
  const { faqs } = props;
  return (
    <div className="bg-linear-to-r from-[#FFEDE7] to-[#FFFBEF] py-12 px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-10">
        {faqs &&
          faqs.map((item) => (
            <div key={item.id} className="text-gray-800">
              <h5 className="font-bold mb-2">{item.faq.question}</h5>
              <div className="text-base leading-relaxed">
                <RichText
                  data={item.faq.answer}
                  enableGutter={false}
                  enableProse={false}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
